import {Component, HostBinding} from '@angular/core';
import {TableColumnDef} from 'app/shared/tables/table-column-def';
import {StoresDataService} from 'app/domain/shops-wrapper/shops/services/stores.data.service';
import {Router} from '@angular/router';
import {ShelfModel} from 'app/domain/shops-wrapper/shops/model/models';

@Component({
  selector: 'pr-shelves-browser',
  templateUrl: './shelves-browser.component.html',
  styleUrls: ['./shelves-browser.component.scss']
})
export class ShelvesBrowserComponent {

    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    navigateLinkArr: Array<string> = ['metadata', 'settings', 'shelves'];

    columnsData: TableColumnDef[];
    tableId: string;
    sortBy = '';

    constructor(
        public storesService: StoresDataService,
        private router: Router
    ) {
        const tableInfo = ShelfModel.tableInfo();
        this.columnsData = tableInfo.columns;
        this.tableId = tableInfo.tableId;
    }

    public createNew(): void {
        this.router.navigateByUrl('metadata/settings/shelves/add');
    }
}
